<template>
    <span :class="{ 'row pl-3': showIcon }">
        <span v-if="showIcon" class="p-0">
            <i
                v-if="webform.submitted_at"
                class="famfamfam-silk accept mr1"
                v-b-tooltip.hover.top
                title="Form submitted by client"
            ></i>
            <i
                v-else-if="webform.is_sent && webform.sent_date"
                class="famfamfam-silk email_go mr1"
                v-b-tooltip.hover.top
                title="Form sent to client and pending submission"
            ></i>
        </span>
        <span :class="{ 'col-9 pl-1': showIcon }">
            <router-link
                v-if="encodedId && useRouter"
                :to="routerParams"
                :target="target"
            >
                {{ webformName }}
            </router-link>
            <a
                v-else-if="encodedId"
                :target="target"
                :href="`/view/settings/template/form/${encodedId}`"
            >
                {{ webformName }}
            </a>
            <span v-else>{{ webformName }}</span>
        </span>
    </span>
</template>

<script>
import TEMPLATES from "@/constants/templates";

export default {
    name: "webformLink",
    props: {
        webform: {
            type: Object,
            required: true
        },
        text: {
            type: String,
            default: null
        },
        routerName: {
            type: String,
            required: true
        },
        useRouter: {
            type: Boolean,
            default: true // in Setting > Appointment type will use false
        },
        withComma: {
            type: Boolean,
            default: false
        },
        withIcon: {
            type: Boolean,
            default: false
        },
        target: {
            type: String,
            default: "_self"
        }
    },
    data() {
        return {};
    },
    computed: {
        webformName() {
            // title used in tbl_webform, name used in tbl_template
            let webformName =
                this.text || this.webform.title || this.webform.name;
            return `${webformName}${this.withComma ? "," : ""}`;
        },
        encodedId() {
            return this.webform.encoded_id || this.webform.encodedId;
        },
        routerParams() {
            if (this.routerName == "template_details") {
                return {
                    name: this.routerName,
                    params: {
                        type:
                            TEMPLATES.LIST[TEMPLATES.TYPE.WEBFORM_TEMPLATE]
                                .route,
                        id: this.encodedId
                    }
                };
            } else {
                return {
                    name: this.routerName,
                    params: {
                        id: this.encodedId
                    }
                };
            }
        },
        showIcon() {
            return (
                this.withIcon &&
                (this.webform.submitted_at ||
                    (this.webform.is_sent && this.webform.sent_date))
            );
        }
    }
};
</script>
<style scoped>
.mr1 {
    margin-right: 1% !important;
}
</style>
